import { render, staticRenderFns } from "./CampaignCompare.vue?vue&type=template&id=88b6e9c2&scoped=true&"
import script from "./CampaignCompare.vue?vue&type=script&lang=js&"
export * from "./CampaignCompare.vue?vue&type=script&lang=js&"
import style0 from "./CampaignCompare.vue?vue&type=style&index=0&id=88b6e9c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b6e9c2",
  null
  
)

export default component.exports